import { MoodWithUserAndEmotion } from 'db-tables'

export function getMoodParticipantName(mood: MoodWithUserAndEmotion): string | undefined {
  if (!mood.anon && !!mood?.user?.name) {
    return mood.user.name
  }
  if (mood.anon_user_name) {
    return mood.anon_user_name
  }
  return undefined
}

export const getInitials = (name: string) => {
  name = name.toUpperCase().trim()
  const names = name.split(' ')
  if (names.length === 1) {
    return name.substring(0, 2)
  }
  return names
    .map((s) => s.substring(0, 1))
    .slice(0, 2)
    .join('')
}
